export class ElementSizeToCssVar {
  #element = null;
  #resizeObserver = null;
  #widthVar = "";
  #heightVar = "";
  #root = false;

  constructor({ width = "", height = "", root = false }) {
    if (!width && !height) {
      throw new Error(
        '[ElementSizeToCssVar]: At least one of "width" or "height" must be provided.'
      );
    }

    this.#widthVar = width;
    this.#heightVar = height;
    this.#root = !!root;
  }

  register(element) {
    if (
      typeof element === "undefined" ||
      typeof element !== "object" ||
      element === null ||
      element.nodeType !== Node.ELEMENT_NODE
    ) {
      throw new Error(
        '[ElementSizeToCssVar]: Expected element to be an instance of HTMLElement but received "' +
          typeof element +
          '"'
      );
    }

    this.#element = element;

    // Calculate the initial size and set CSS variables
    this.#updateCssVars();

    // Use ResizeObserver if supported
    if (typeof ResizeObserver !== "undefined") {
      this.#resizeObserver = new ResizeObserver(() => this.#updateCssVars());
      this.#resizeObserver.observe(this.#element);
    } else {
      // Fallback to resize and orientationchange events
      window.addEventListener("resize", this.#updateCssVars);
      window.addEventListener("orientationchange", this.#updateCssVars);
    }

    return this; // Enable chaining
  }

  #updateCssVars = () => {
    if (!this.#element) return;

    const { offsetWidth: width, offsetHeight: height } = this.#element;

    // Set the provided CSS variables on the element
    const cssVarElement = this.#root ? document.body : this.#element;
    if (this.#widthVar) {
      cssVarElement.style.setProperty(this.#widthVar, `${width}px`);
    }
    if (this.#heightVar) {
      cssVarElement.style.setProperty(this.#heightVar, `${height}px`);
    }
  };

  unregister() {
    // If using ResizeObserver, disconnect it
    if (this.#resizeObserver) {
      this.#resizeObserver.disconnect();
      this.#resizeObserver = null;
    } else {
      // Remove fallback event listeners
      window.removeEventListener("resize", this.#updateCssVars);
      window.removeEventListener("orientationchange", this.#updateCssVars);
    }

    // Remove CSS variables
    if (this.#element) {
      if (this.#widthVar) {
        this.#element.style.removeProperty(this.#widthVar);
      }
      if (this.#heightVar) {
        this.#element.style.removeProperty(this.#heightVar);
      }
    }

    this.#element = null;
  }
}
